import { Action } from 'redux'
import * as Actions from './actionTypes'
import { ServiceContract, ServiceContractRecordsFilters } from 'src/common/models/contract';
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions';
import { ServiceContractDebitRecordsFilters, ServiceDebitContract } from 'src/common/models/serviceContractDebit';
import { SuccessResponse } from 'src/common/models/common';

export interface UpdateContractAction extends Action {
    contractFields: Partial<ServiceContract>;
    serviceContracts?: ServiceContract[]
}

export const updateCurrentContract = (contractFields: Partial<ServiceContract>): UpdateContractAction => {
    return {
        type: Actions.UPDATE_CURRENT_CONTRACT,
        contractFields,
    }
};

export const cleanCurrentContract = (): Action => {
    return {
        type: Actions.CLEAN_CURRENT_CONTRACT,
    }
};

export interface CreateServiceContractAction extends Action {
    serviceContract: ServiceContract
}
export interface CreateServiceContractSuccessAction extends Action {
    serviceContract: ServiceContract
}
export const createServiceContractApi = (serviceContract: ServiceContract): CreateServiceContractAction => ({
    type: Actions.CREATE_SERVICE_CONTRACT_API,
    serviceContract,
})
export const createServiceContractApiSuccess = (serviceContract: ServiceContract): CreateServiceContractSuccessAction => ({
    type: Actions.CREATE_SERVICE_CONTRACT_API_SUCCESS,
    serviceContract,
})
export const createServiceContractApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.CREATE_SERVICE_CONTRACT_API_ERROR,
    error,
)

export interface GetServiceContractsAction extends Action {
    filters?: ServiceContractRecordsFilters
}
export interface GetServiceContractsSuccessAction extends Action {
    serviceContracts: ServiceContract[]
}
export const getServiceContractsApi = (filters?: ServiceContractRecordsFilters): GetServiceContractsAction => ({
    type: Actions.GET_SERVICE_CONTRACTS_API,
    filters,
})
export const getServiceContractsApiSuccess = (serviceContracts: ServiceContract[]): GetServiceContractsSuccessAction => ({
    type: Actions.GET_SERVICE_CONTRACTS_API_SUCCESS,
    serviceContracts,
})
export const getServiceContractsApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_SERVICE_CONTRACTS_API_ERROR,
    error,
)

export interface GetServiceContractByIdAction extends Action {
    id: number
}
export interface GetServiceContractByIdSuccessAction extends Action {
    serviceContract: ServiceContract
}
export const getServiceContractByIdApi = (id: number): GetServiceContractByIdAction => ({
    type: Actions.GET_CONTRACT_BY_ID_API,
    id,
})
export const getServiceContractByIdApiSuccess = (serviceContract: ServiceContract): GetServiceContractByIdSuccessAction => ({
    type: Actions.GET_CONTRACT_BY_ID_API_SUCCESS,
    serviceContract,
})
export const getServiceContractByIdApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_CONTRACT_BY_ID_API_ERROR,
    error,
)

export interface GetServiceContractDebitsAction extends Action {
    filters?: ServiceContractDebitRecordsFilters
}
export interface GetServiceContractDebitsSuccessAction extends Action {
    serviceContractDebits: ServiceDebitContract[]
}
export const getServiceContractDebitsApi = (filters?: ServiceContractDebitRecordsFilters): GetServiceContractDebitsAction => ({
    type: Actions.GET_SERVICE_CONTRACT_DEBITS_API,
    filters,
})
export const getServiceContractDebitsApiSuccess = (serviceContractDebits: ServiceDebitContract[]): GetServiceContractDebitsSuccessAction => ({
    type: Actions.GET_SERVICE_CONTRACT_DEBITS_API_SUCCESS,
    serviceContractDebits,
})
export const getServiceContractDebitsApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_SERVICE_CONTRACT_DEBITS_API_ERROR,
    error,
)

export interface GetContractDebitByIdAction extends Action {
    id: number
}
export interface GetContractDebitByIdSuccessAction extends Action {
    contractDebit: ServiceDebitContract
}
export const getContractDebitByIdApi = (id: number): GetContractDebitByIdAction => ({
    type: Actions.GET_CONTRACT_DEBIT_BY_ID_API,
    id,
})
export const getContractDebitByIdApiSuccess = (contractDebit: ServiceDebitContract): GetContractDebitByIdSuccessAction => ({
    type: Actions.GET_CONTRACT_DEBIT_BY_ID_API_SUCCESS,
    contractDebit,
})
export const getContractDebitByIdApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_CONTRACT_DEBIT_BY_ID_API_ERROR,
    error,
)

export const cleanCurrentContractDebit = (): Action => {
    return {
        type: Actions.CLEAN_CURRENT_CONTRACT_DEBIT,
    }
};

export interface UpdateServiceContractAction extends Action {
    serviceContract: ServiceContract
}
export interface UpdateServiceContractSuccessAction extends Action {
    serviceContract: ServiceContract
}
export const updateServiceContractApi = (serviceContract: ServiceContract): UpdateServiceContractAction => ({
    type: Actions.UPDATE_SERVICE_CONTRACT_API,
    serviceContract,
})
export const updateServiceContractApiSuccess = (serviceContract: ServiceContract): UpdateServiceContractSuccessAction => ({
    type: Actions.UPDATE_SERVICE_CONTRACT_API_SUCCESS,
    serviceContract,
})
export const updateServiceContractApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.UPDATE_SERVICE_CONTRACT_API_ERROR,
    error,
)

export interface DeleteServiceContractDebitAction extends Action {
    id: number
}
export interface DeleteServiceContractDebitSuccessAction extends Action {
    response: SuccessResponse
}
export const deleteServiceContractDebitApi = (id: number): DeleteServiceContractDebitAction => ({
    type: Actions.DELETE_SERVICE_CONTRACT_DEBIT_API,
    id,
})
export const deleteServiceContractDebitApiSuccess = (response: SuccessResponse): DeleteServiceContractDebitSuccessAction => ({
    type: Actions.DELETE_SERVICE_CONTRACT_DEBIT_API_SUCCESS,
    response,
})
export const deleteServiceContractDebitApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.DELETE_SERVICE_CONTRACT_DEBIT_API_ERROR,
    error,
)